/**
 * Dragging to the bottom of a long board has to bring the board with it,
 * because the cursor can't leave the window and the board is taller than it.
 */

/** Auto-scroll begins this far from the edge of the scrolling box. */
const EDGE = 80;

/** Pixels a frame at the very edge, tapering to nothing at the boundary. */
const SPEED = 16;

/** Scrolls if the point is in the margin. Returns whether it moved. */
export function edgeScroll(scroller: HTMLElement | null, y: number): boolean {
  if (scroller === null) return false;

  const box = scroller.getBoundingClientRect();
  const above = (box.top + EDGE - y) / EDGE;
  const below = (y - (box.bottom - EDGE)) / EDGE;

  let by = 0;
  if (above > 0) by = -SPEED * Math.min(above, 1);
  else if (below > 0) by = SPEED * Math.min(below, 1);
  if (by === 0) return false;

  const was = scroller.scrollTop;
  scroller.scrollTop += by;
  return scroller.scrollTop !== was;
}
